import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CART_TIP_PICKER_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { CartTipPickerBlockScenarioContent } from '@front-platform/content-builder';

import {
  CART_TIP_PICKER_BLOCK_LOADING_VM,
  CartTipPickerBlockDataSource,
  CartTipPickerBlockViewModel,
} from './cart-tip-picker-block-view-model';

function toCartTipPickerPreviewViewModel(
  content: CartTipPickerBlockScenarioContent,
): CartTipPickerBlockViewModel {
  return {
    tipsAllowed: content.tipsAllowed,
    totalAmount: content.totalAmount,
    selectedTip: content.selectedTip,
  };
}

@Injectable()
export class CartTipPickerBlockPreviewDataSource implements CartTipPickerBlockDataSource {
  readonly vm$: Observable<CartTipPickerBlockViewModel> = previewScenarioForBloc$(
    CART_TIP_PICKER_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return CART_TIP_PICKER_BLOCK_LOADING_VM;
      }
      const content = previewScenarioData<CartTipPickerBlockScenarioContent>(
        scenario,
        CART_TIP_PICKER_BLOCK_COMPONENT,
      );
      return content ? toCartTipPickerPreviewViewModel(content) : CART_TIP_PICKER_BLOCK_LOADING_VM;
    }),
  );
}
